export default __webpack_public_path__ + "static/media/6.0a82c587.jpg";